// Navigation
document.addEventListener("DOMContentLoaded", function () {
    const menuToggle = document.getElementById("menu-toggle");
    const navContainer = document.querySelector(".nav-container");
    const body = document.body;

    if (menuToggle) {
        menuToggle.addEventListener("click", function () {
            menuToggle.classList.toggle("is-active");
            navContainer.classList.toggle("menu-active");
            body.classList.toggle("menu-open");
        });
    }
});

// Nav dropdowns - click/touch only
document.querySelectorAll(".nav-item > a").forEach((link) => {
    link.addEventListener("click", (e) => {
        const navItem = link.closest(".nav-item");
        const dropdown = navItem.querySelector(".nav-dropdown");
        if (!dropdown) return;

        e.preventDefault();

        document
            .querySelectorAll(
                ".nav-item.is-open, .nav-dropdown__item--has-children.is-open",
            )
            .forEach((item) => {
                if (item !== navItem) item.classList.remove("is-open");
            });

        navItem.classList.toggle("is-open");
    });
});

// Close on click outside
document.addEventListener("click", (e) => {
    if (!e.target.closest(".nav-item")) {
        document.querySelectorAll(".nav-item.is-open").forEach((item) => {
            item.classList.remove("is-open");
        });
    }
});

// Nested dropdown items
document
    .querySelectorAll(".nav-dropdown__item--has-children:not(.nav-item-separate) > a")
    .forEach((link) => {
        link.addEventListener("click", (e) => {
            e.preventDefault();
            const item = link.closest(".nav-dropdown__item");

            item.closest(".nav-dropdown")
                .querySelectorAll(".nav-dropdown__item--has-children.is-open")
                .forEach((sibling) => {
                    if (sibling !== item) sibling.classList.remove("is-open");
                });

            item.classList.toggle("is-open");
            link.blur();
        });
    });

// Hero slider
const heroSlider = document.querySelector(".block-hero-slider");
if (heroSlider) {
    new Swiper(".block-hero-slider", {
        loop: true,
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });
}

// Staff and fees tabs
document
    .querySelectorAll(".block-staff-tabs, .block-fees-table")
    .forEach((block) => {
        // Set first tab active on load
        const firstTab = block.querySelector("[data-tab]");
        const firstPanel = block.querySelector("[data-panel]");
        if (firstTab) firstTab.classList.add("is-active");
        if (firstPanel) firstPanel.classList.add("is-active");

        // Tab click handler
        block.querySelectorAll("[data-tab]").forEach((btn) => {
            btn.addEventListener("click", () => {
                const tab = btn.dataset.tab;

                block
                    .querySelectorAll("[data-tab]")
                    .forEach((b) => b.classList.remove("is-active"));
                block
                    .querySelectorAll("[data-panel]")
                    .forEach((p) => p.classList.remove("is-active"));

                btn.classList.add("is-active");
                block
                    .querySelector(`[data-panel="${tab}"]`)
                    .classList.add("is-active");
            });
        });
    });

// OpenStreetMap
document.querySelectorAll(".block-map__osm").forEach((el) => {
    const lat = parseFloat(el.dataset.lat);
    const lng = parseFloat(el.dataset.lng);
    const zoom = parseInt(el.dataset.zoom) || 15;
    const label = el.dataset.label || "";

    const map = L.map(el).setView([lat, lng], zoom);

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution:
            '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    }).addTo(map);

    if (label) {
        L.marker([lat, lng]).addTo(map).bindPopup(label).openPopup();
    }
});

document.addEventListener("DOMContentLoaded", () => {
    bindClickable();

    const descriptionBlocks = document.querySelectorAll(
        ".practice-page__description-content[data-trim-length]",
    );

    descriptionBlocks.forEach((block) => {
        const trimLength = parseInt(block.dataset.trimLength);
        const rawHTML = block.innerHTML
            .replace(/^\s*<br\s*\/?>\s*/i, "")
            .trim();
        const fullHTML = rawHTML.startsWith("<p>")
            ? rawHTML
            : `<p>${rawHTML}</p>`;
        const fullText = block.textContent.trim();

        if (fullText.length <= trimLength) {
            // Hide button if content is short enough
            const btn = block.nextElementSibling;
            if (btn) btn.style.display = "none";
            return;
        }

        // Trim on load
        const trimmed = fullText.substring(0, trimLength).trim() + "...";
        block.innerHTML = `<p>${trimmed}</p>`;

        const btn = block.nextElementSibling;
        if (!btn) return;

        btn.addEventListener("click", () => {
            const expanded = btn.getAttribute("aria-expanded") === "true";
            if (expanded) {
                block.innerHTML = `<p>${trimmed}</p>`;
                btn.textContent = "Read More";
                btn.setAttribute("aria-expanded", "false");
            } else {
                block.innerHTML = fullHTML;
                btn.textContent = "Show Less";
                btn.setAttribute("aria-expanded", "true");
            }
        });
    });

    const searchBtn = document.querySelectorAll('header .search-btn');
    if (searchBtn) {
        searchBtn.forEach(function (btn) {
            watchSearch(btn);
        })
    }

    const searchResults = document.getElementById('SearchResults');
    if (searchResults) {
        const firstLink = searchResults.querySelector('.first a');
        if (firstLink) {
            firstLink.focus();
        }
    }

    const popup = document.querySelector('.popup-banners-container');
    if (popup) {
        watchPopupBanners();
    }

    const alert = document.querySelector('.alert-bars');
    if (alert) {
        watchAlerts();
    }
});

function watchAlerts() {
    const alertBars = document.querySelectorAll('.alert-bar');
    const header = document.querySelector('header');
    const navContainer = document.querySelector('.nav-container');
    const body = document.querySelector('body');

    function updateHeaderPosition() {
        let totalHeight = 0;

        alertBars.forEach(function (bar) {
            if (!bar.classList.contains('inactive') && bar.style.display !== 'none') {
                totalHeight += bar.offsetHeight;
            }
        });

        if (header) {
            header.style.top = totalHeight + 'px';
        }

        if (body.classList.contains('menu-open')) {
            body.classList.add('popup-lock-scroll');
            navContainer.style.top = totalHeight + 91 + 'px';
        }
    }

    updateHeaderPosition();

    alertBars.forEach(function (alertBar) {
        const closeBtn = alertBar.querySelector('.alert-close');
        const links = alertBar.querySelectorAll('a:not(.alert-close)');

        function closeBanner() {
            alertBar.classList.add('inactive');
            alertBar.addEventListener('transitionend', function handler() {
                alertBar.style.display = 'none';
                alertBar.removeEventListener('transitionend', handler);
                updateHeaderPosition();
            });
        }

        links.forEach(function (link) {
            link.addEventListener('click', function () {
                setCookie('alert-hidden-' + alertBar.dataset.alertkey, alertBar.dataset.alertcode, 0.5);
                closeBanner();
            });
        });

        if (closeBtn) {
            closeBtn.addEventListener('click', function () {
                setCookie('alert-hidden-' + alertBar.dataset.alertkey, alertBar.dataset.alertcode, 0.5);
                closeBanner();
            });
        }
    });
}

const bindClickable = () => {
    document.querySelectorAll(".clickable").forEach((card) => {
        const link = card.querySelector("a");

        if (link) {
            card.addEventListener("click", () => {
                link.click();
            });
            card.classList.add("ready");
        }
    });
};

function setCookie(cname, cvalue, exdays = null) {
    let expires = "";
    if (exdays !== null) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        expires = "expires=" + d.toUTCString() + ";";
    }
    document.cookie = cname + "=" + cvalue + ";" + expires + "path=/";
}

function watchPopupBanners() {
    const popupParent = document.querySelector('.popup-banners-container');
    const popupBanners = document.querySelectorAll('.popup.popup-banner-container');
    const numBanners = popupBanners.length;
    let currNum = 0;

    if (numBanners === 0) {
        if (popupParent) {
            popupParent.style.display = 'none';
        }
        document.body.classList.remove('popup-lock-scroll')
        return;
    }

    const scrollThreshold = 0.3 + Math.random() * 0.2;

    function activateFirstBanner() {
        popupParent.style.display = 'flex'
        document.body.classList.add('popup-lock-scroll');

        const hasActive = Array.from(popupBanners).some(function (banner) {
            return banner.classList.contains('active');
        });

        if (!hasActive) {
            popupBanners[0].classList.add('active');
        }

        clearTimeout(timeoutId);
        document.removeEventListener('mouseleave', handleExitIntent);
        document.removeEventListener('scroll', handleScrollIntent);
    }

    function handleExitIntent(e) {
        if (e.clientY <= 0) {
            activateFirstBanner();
        }
    }

    function handleScrollIntent() {
        const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
        if (scrollableHeight <= 0) {
            return;
        }
        const scrolledFraction = window.scrollY / scrollableHeight;
        if (scrolledFraction >= scrollThreshold) {
            activateFirstBanner();
        }
    }

    const timeoutId = setTimeout(activateFirstBanner, 30000);
    document.addEventListener('mouseleave', handleExitIntent);
    document.addEventListener('scroll', handleScrollIntent);

    popupBanners.forEach(function (popupBanner, index) {
        const closeBtn = popupBanner.querySelector('.popup-close');
        const links = popupBanner.querySelectorAll('a:not(.popup-close)');

        function closeBanner() {
            popupBanner.classList.remove('active');
            popupBanner.style.display = 'none';

            currNum += 1;

            if (currNum === numBanners) {
                if (popupParent) {
                    popupParent.style.display = 'none';
                }
                document.body.classList.remove('popup-lock-scroll');
            } else {
                const nextBanner = popupBanners[index + 1];
                if (nextBanner) {
                    nextBanner.classList.add('active');
                }
            }
        }

        links.forEach(function (link) {
            link.addEventListener('click', function () {
                setCookie('popup-hidden-' + popupBanner.dataset.popupkey, popupBanner.dataset.popupcode, 30);
                closeBanner();
            });
        });

        if (closeBtn) {
            closeBtn.addEventListener('click', function () {
                setCookie('popup-hidden-' + popupBanner.dataset.popupkey, popupBanner.dataset.popupcode, 3);
                closeBanner();
            });
        }
    });
}

function watchSearch(btn) {
    const targetBtn = btn;
    const targetEle = document.querySelector('.form-container.header-form-container');
    const hiddenEle = targetEle ? targetEle.querySelector('#SearchForm_SearchForm') : null;
    const phoneLink = document.querySelector('header .phone-link-container');

    if (targetEle) targetEle.style.display = 'none';
    if (hiddenEle) hiddenEle.style.display = 'none';

    if (targetBtn) {
        targetBtn.addEventListener('click', function (event) {
            event.preventDefault();
            targetEle.classList.toggle('active');

            if (!targetEle.classList.contains('active')) {
                if (targetBtn.getAttribute('aria-expanded') === 'true') {
                    targetBtn.setAttribute('aria-expanded', 'false');
                }
                if (hiddenEle) hiddenEle.style.display = 'none';
                targetEle.style.height = '0';
                targetEle.style.height = '125px';
                if (phoneLink) phoneLink.classList.toggle('active');
                window.setTimeout(function () {
                    targetEle.style.display = 'none';
                    targetEle.style.height = '';
                    targetEle.style.position = 'unset';
                    targetEle.style.zIndex = 'unset';
                }, 250);
                if (hiddenEle) hiddenEle.style.display = 'none';
                const height = targetEle.offsetHeight;
                targetEle.style.height = height + 'px';
                targetEle.style.height = '0';
                window.setTimeout(function () {
                    targetEle.style.display = 'none';
                    targetEle.style.height = '';
                }, 250);
            } else {
                if (targetBtn.getAttribute('aria-expanded') === 'false') {
                    targetBtn.setAttribute('aria-expanded', 'true');
                }
                targetEle.style.display = 'block';
                targetEle.style.position = 'relative';
                targetEle.style.zIndex = '50';
                window.setTimeout(function () {
                    targetEle.style.height = '0';
                    targetEle.style.height = '125px';
                    if (phoneLink) phoneLink.classList.toggle('active');
                }, 250);
                window.setTimeout(function () {
                    if (hiddenEle) hiddenEle.style.display = 'block';
                    const searchInput = document.getElementById('SearchFormExtension_SearchForm_Search');
                    if (searchInput) searchInput.focus();
                }, 450);
            }
        });
    }
}

document
    .querySelectorAll(
        ".block-child-link-list--carousel .block-child-link-list__swiper",
    )
    .forEach((el) => {
        new Swiper(el, {
            slidesPerView: 1.2,
            spaceBetween: 10,
            autoHeight: false,
            equalHeight: true,
            pagination: {
                el: el.querySelector(".swiper-pagination"),
                clickable: true,
                dynamicBullets: true,
            },
            navigation: {
                nextEl: el.querySelector(".swiper-button-next"),
                prevEl: el.querySelector(".swiper-button-prev"),
            },
            breakpoints: {
                640: {slidesPerView: 2.2},
                1024: {slidesPerView: 3.5},
                1440: {slidesPerView: 4.5},
            },
        });
    });

const heroBanner = document.querySelector(".block-hero-banner__swiper");
heroBanner &&
new Swiper(".block-hero-banner__swiper", {
    loop: true,
    effect: "fade",
    autoplay: {
        delay: 4000,
        disableOnInteraction: false,
    },
});

// Find a Practice page - Leaftlet

// function initFindAPractice() {
//     const mapEl = document.getElementById("find-a-practice-map");
//     if (!mapEl) return;

//     const cards = document.querySelectorAll(".practice-card");
//     const searchInput = document.getElementById("practice-search");
//     const regionSelect = document.getElementById("practice-region");
//     const enrolmentFilter = document.getElementById(
//         "practice-enrolment-filter",
//     );
//     const countEl = document.getElementById("practice-count");

//     // Init map
//     const map = L.map("find-a-practice-map").setView([-41.0, 174.0], 5);
//     L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
//         attribution:
//             '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
//     }).addTo(map);

//     // if (!searchInput || !regionSelect) return;

//     // Add markers
//     const markers = [];
//     cards.forEach((card) => {
//         const lat = parseFloat(card.dataset.lat);
//         const lng = parseFloat(card.dataset.lng);
//         const name = card.querySelector(".practice-card__name a").textContent;
//         const link = card.querySelector(".practice-card__name a").href;
//         const address = card.querySelector(".practice-card__address")
//             ? card.querySelector(".practice-card__address").textContent.trim()
//             : "";

//         if (lat && lng) {
//             const marker = L.marker([lat, lng])
//                 .addTo(map)
//                 .bindPopup(
//                     `<strong><a href="${link}">${name}</a></strong><br>${address}`,
//                 );
//             markers.push({ marker, card });

//             // Click card to open popup
//             card.addEventListener("click", () => {
//                 map.setView([lat, lng], 14);
//                 marker.openPopup();
//             });
//         }
//     });

//     // Filter
//     function filterPractices() {
//         const search = searchInput.value.toLowerCase();
//         const region = regionSelect.value;
//         const enrolmentOnly = enrolmentFilter.checked;
//         let visible = 0;

//         cards.forEach((card) => {
//             const nameMatch =
//                 card.dataset.name.includes(search) ||
//                 card.dataset.address.includes(search);
//             const regionMatch = !region || card.dataset.region === region;
//             const enrolmentMatch =
//                 !enrolmentOnly || card.dataset.enrolment === "Open";
//             const show = nameMatch && regionMatch && enrolmentMatch;

//             card.style.display = show ? "block" : "none";

//             // Show/hide markers
//             const markerData = markers.find((m) => m.card === card);
//             if (markerData) {
//                 if (show) {
//                     markerData.marker.addTo(map);
//                 } else {
//                     markerData.marker.remove();
//                 }
//             }

//             if (show) visible++;
//         });

//         if (countEl) countEl.textContent = visible;
//     }

//     searchInput?.addEventListener("input", filterPractices);
//     regionSelect?.addEventListener("change", filterPractices);
//     enrolmentFilter?.addEventListener("change", filterPractices);
// }

// initFindAPractice();

// Find a Practice - Google Maps

const PROXIMITY_RADIUS_KM = 50;

function haversineDistanceKm(lat1, lng1, lat2, lng2) {
    const R = 6371;
    const toRad = (deg) => (deg * Math.PI) / 180;
    const dLat = toRad(lat2 - lat1);
    const dLng = toRad(lng2 - lng1);
    const a =
        Math.sin(dLat / 2) ** 2 +
        Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;

    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

window.initFindAPracticeMap = function () {
    const mapEl = document.getElementById("find-a-practice-map");

    if (!mapEl) {
        return;
    }

    const cards = document.querySelectorAll(".practice-card");
    const originalCardOrder = Array.from(cards);
    const listContainer = document.getElementById("practice-list");
    const searchInput = document.getElementById("practice-search");
    const findBtn = document.querySelector(
        ".find-a-practice__search-input-wrap .block-find-practice-search__btn",
    );
    const geolocateBtn = document.querySelector(".find-a-practice .geolocate");
    const regionSelect = document.getElementById("practice-region");
    const enrolmentFilter = document.getElementById(
        "practice-enrolment-filter",
    );
    const countEl = document.getElementById("practice-count");

    const markers = [];

    const map = new google.maps.Map(mapEl, {
        center: {lat: -41.0, lng: 174.0},
        zoom: 5,
    });

    const infoWindow = new google.maps.InfoWindow();

    cards.forEach((card) => {
        const lat = parseFloat(card.dataset.lat);
        const lng = parseFloat(card.dataset.lng);

        if (Number.isNaN(lat) || Number.isNaN(lng)) {
            return;
        }

        const nameEl = card.querySelector(".practice-card__name a");

        if (!nameEl) {
            return;
        }

        const name = nameEl.textContent;
        const link = nameEl.href;
        const address =
            card.querySelector(".practice-card__address")?.textContent.trim() ||
            "";

        const marker = new google.maps.Marker({
            position: {lat, lng},
            map,
            title: name,
        });

        marker.addListener("click", () => {
            infoWindow.setContent(`
                <strong><a href="${link}">${name}</a></strong><br>
                ${address}
            `);

            infoWindow.open({
                anchor: marker,
                map,
            });
        });

        markers.push({marker, card});

        card.addEventListener("click", () => {
            map.setCenter({lat, lng});
            map.setZoom(14);

            infoWindow.setContent(`
                <strong><a href="${link}">${name}</a></strong><br>
                ${address}
            `);

            infoWindow.open({
                anchor: marker,
                map,
            });
        });
    });

    let proximity = null;

    function getCardDistanceKm(card) {
        if (!proximity) {
            return null;
        }

        const lat = parseFloat(card.dataset.lat);
        const lng = parseFloat(card.dataset.lng);

        if (Number.isNaN(lat) || Number.isNaN(lng)) {
            return Infinity;
        }

        return haversineDistanceKm(proximity.lat, proximity.lng, lat, lng);
    }

    function reorderCards() {
        if (!listContainer) {
            return;
        }

        const order = proximity
            ? originalCardOrder
                .slice()
                .sort((a, b) => getCardDistanceKm(a) - getCardDistanceKm(b))
            : originalCardOrder;

        order.forEach((card) => listContainer.appendChild(card));
    }

    function filterPractices() {
        const region = regionSelect?.value || "";
        const enrolmentOnly = enrolmentFilter?.checked || false;

        let visible = 0;

        cards.forEach((card) => {
            const regionMatch = !region || card.dataset.region === region;

            const enrolmentMatch =
                !enrolmentOnly || card.dataset.enrolment === "Open";

            const proximityMatch =
                !proximity || getCardDistanceKm(card) <= proximity.radiusKm;

            const show = regionMatch && enrolmentMatch && proximityMatch;

            card.style.display = show ? "block" : "none";

            const markerData = markers.find((m) => m.card === card);

            if (markerData) {
                markerData.marker.setVisible(show);
            }

            if (show) {
                visible++;
            }
        });

        if (countEl) {
            countEl.textContent = visible;
        }

        reorderCards();
    }

    function setProximity(lat, lng, radiusKm = PROXIMITY_RADIUS_KM) {
        proximity = {lat, lng, radiusKm};
        map.setCenter({lat, lng});
        map.setZoom(11);
        filterPractices();
    }

    let placesLibraryPromise = null;

    function getPlacesLibrary() {
        if (!placesLibraryPromise) {
            placesLibraryPromise = google.maps.importLibrary("places");
        }

        return placesLibraryPromise;
    }

    const geocoder = new google.maps.Geocoder();

    function searchByText(query) {
        query = (query || "").trim();

        if (!query) {
            proximity = null;
            filterPractices();
            return;
        }

        geocoder.geocode(
            {
                address: query,
                componentRestrictions: {country: "NZ"},
            },
            (results, status) => {
                if (
                    status === google.maps.GeocoderStatus.OK &&
                    results?.[0]?.geometry?.location
                ) {
                    const location = results[0].geometry.location;
                    setProximity(location.lat(), location.lng());
                } else {
                    proximity = null;
                    filterPractices();
                }
            },
        );
    }

    if (searchInput) {
        getPlacesLibrary().then((places) => {
            const autocomplete = new places.Autocomplete(searchInput, {
                componentRestrictions: {country: "nz"},
                fields: ["geometry", "name"],
            });

            autocomplete.addListener("place_changed", () => {
                const place = autocomplete.getPlace();
                const location = place?.geometry?.location;

                if (location) {
                    setProximity(location.lat(), location.lng());
                } else {
                    searchByText(place?.name || searchInput.value);
                }
            });
        });
    }

    function geolocateUser() {
        if (!navigator.geolocation) {
            return;
        }

        if (searchInput) {
            searchInput.value = "";
        }

        navigator.geolocation.getCurrentPosition((position) => {
            setProximity(position.coords.latitude, position.coords.longitude);
        });
    }

    searchInput?.addEventListener("input", () => {
        if (searchInput.value === "") {
            proximity = null;
            filterPractices();
        }
    });

    findBtn?.addEventListener("click", (e) => {
        e.preventDefault();
        searchByText(searchInput?.value);
    });

    geolocateBtn?.addEventListener("click", (e) => {
        e.preventDefault();
        geolocateUser();
    });

    geolocateBtn?.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            geolocateUser();
        }
    });

    regionSelect?.addEventListener("change", filterPractices);
    enrolmentFilter?.addEventListener("change", filterPractices);

    if (geolocateBtn?.classList.contains("auto")) {
        geolocateUser();
    } else if (searchInput?.value.trim()) {
        searchByText(searchInput.value);
    } else {
        filterPractices();
    }
};

// Pre-fill find a practice search from URL params
const urlParams = new URLSearchParams(window.location.search);
const searchParam = urlParams.get("search");
if (searchParam && document.getElementById("practice-search")) {
    document.getElementById("practice-search").value = searchParam;
}

function initStaffModal() {
    const modal = document.getElementById("staff-modal");

    if (!modal) {
        return;
    }

    const modalPhoto = document.getElementById("staff-modal-photo");
    const modalName = document.getElementById("staff-modal-name");
    const modalRole = document.getElementById("staff-modal-role");
    const modalBio = document.getElementById("staff-modal-bio");

    const closeModal = () => {
        modal.classList.remove("is-open");
        modal.setAttribute("aria-hidden", "true");
        document.body.style.overflow = "";
    };

    document.querySelectorAll(".block-staff-tabs__more-info").forEach((btn) => {
        btn.addEventListener("click", () => {
            const card = btn.closest(".block-staff-tabs__card");

            if (!card) {
                return;
            }

            const {name, role, bio, photo} = card.dataset;

            modalName.textContent = name || "";
            modalRole.textContent = role || "";
            modalBio.textContent = bio || "";

            modalPhoto.innerHTML = photo
                ? `<img src="${photo}" alt="${name}">`
                : "";

            modal.classList.add("is-open");
            modal.setAttribute("aria-hidden", "false");
            document.body.style.overflow = "hidden";
        });
    });

    modal
        .querySelector(".staff-modal__close")
        ?.addEventListener("click", closeModal);

    modal
        .querySelector(".staff-modal__overlay")
        ?.addEventListener("click", closeModal);

    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && modal.classList.contains("is-open")) {
            closeModal();
        }
    });
}

document.addEventListener("DOMContentLoaded", initStaffModal);

// // Practice page subnav active state
const subnavLinks = document.querySelectorAll(".practice-page__subnav a");

if (subnavLinks.length) {
    subnavLinks[0].classList.add("is-active");

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const id = entry.target.id;
                    subnavLinks.forEach((link) => {
                        link.classList.remove("is-active");
                        if (link.getAttribute("href").includes(`#${id}`)) {
                            link.classList.add("is-active");
                        }
                    });
                }
            });
        },
        {threshold: 0.3},
    );

    document
        .querySelectorAll(".practice-page__content .element[id]")
        .forEach((el) => {
            observer.observe(el);
        });
}

// News filter
document.querySelectorAll(".news-holder__filter-btn").forEach((btn) => {
    btn.addEventListener("click", () => {
        const filter = btn.dataset.filter;

        document
            .querySelectorAll(".news-holder__filter-btn")
            .forEach((b) => b.classList.remove("is-active"));
        btn.classList.add("is-active");

        document.querySelectorAll(".news-card").forEach((card) => {
            const show = filter === "all" || card.dataset.category === filter;
            card.style.display = show ? "block" : "none";
        });
    });
});
